
import dayjs from 'dayjs';

export default ({ date, quantity, interval = 'days' }) => {
  return dayjs(date)
    .add(quantity, interval);
}
